import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MobileMenu from './MobileMenu';

class MobileDrawer extends Component {
  state = {
    isOpen: false
  };

  toggleDrawer = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    const { mobileMenuColor } = this.props;
    return (
      <MobileMenu
        isDrawerOpen={this.state.isOpen}
        parentToggleDrawer={this.toggleDrawer}
        mobileMenuColor={mobileMenuColor}
      />
    );
  }
}

MobileDrawer.propTypes = {
  mobileMenuColor: PropTypes.oneOf(['alt', 'secondary'])
};

MobileDrawer.defaultProps = {
  mobileMenuColor: 'alt'
};

export default MobileDrawer;
